<template>
  <div class="form-layout-settings">
    <div class="layout-option-container" v-for="option in layoutSpacingOptions">
      <div class="switch-group">
        <label class="caption">{{ option.label }}</label>

        <CommonSwitch
          v-model="task.props.settings.layout.spacing"
          :isDisabled="!isUserHasAccess"
          class="large-size"
          type="radio"
          :radioValue="option.value"
          @input="onValueChange"
        />
      </div>
    </div>

    <template v-if="layoutSetting?.spacing == 'custom'">
      <div class="screen-selector">
        <div
          v-for="screen in screenSizeOptions"
          :key="screen.name"
          @click="onSelectScreen(screen)"
        >
          <img
            :class="{ active: screen.name == selectedScreen }"
            class="screen-icon"
            :src="
              getScreenIcons(
                screen.name == selectedScreen ? screen.activeIcon : screen.icon
              )
            "
          />
        </div>
      </div>
      <div class="layout-spacing-inputs">
        <div>
          <div class="input-element">
            <label>Top</label>
            <input
              v-model.number="
                task.props.settings.layout.customSpacing[selectedScreen].top
                  .value
              "
              type="number"
            />
            <CustomDropdown>
              <template v-slot:selected-option>
                <span class="line-clamp"
                  >{{ layoutSetting?.customSpacing[selectedScreen].top.unit }}
                </span>
              </template>
              <template v-slot:option-data>
                <b-dropdown-item
                  v-for="unit in unitOptions"
                  :key="unit"
                  @click="onSelectSpacingUnit(unit, 'top')"
                >
                  {{ unit }}
                </b-dropdown-item>
              </template>
            </CustomDropdown>
          </div>
          <div class="input-element">
            <label>Bottom</label>
            <input
              v-model.number="
                task.props.settings.layout.customSpacing[selectedScreen].bottom
                  .value
              "
              type="number"
            />

            <CustomDropdown>
              <template v-slot:selected-option>
                <span class="line-clamp"
                  >{{
                    layoutSetting?.customSpacing[selectedScreen].bottom.unit
                  }}
                </span>
              </template>
              <template v-slot:option-data>
                <b-dropdown-item
                  v-for="unit in unitOptions"
                  :key="unit"
                  @click="onSelectSpacingUnit(unit, 'bottom')"
                >
                  {{ unit }}
                </b-dropdown-item>
              </template>
            </CustomDropdown>
          </div>
        </div>
        <div>
          <div class="input-element">
            <label>Left</label>
            <input
              v-model.number="
                task.props.settings.layout.customSpacing[selectedScreen].left
                  .value
              "
              type="number"
            />
            <CustomDropdown>
              <template v-slot:selected-option>
                <span class="line-clamp"
                  >{{ layoutSetting?.customSpacing[selectedScreen].left.unit }}
                </span>
              </template>
              <template v-slot:option-data>
                <b-dropdown-item
                  v-for="unit in unitOptions"
                  :key="unit"
                  @click="onSelectSpacingUnit(unit, 'left')"
                >
                  {{ unit }}
                </b-dropdown-item>
              </template>
            </CustomDropdown>
          </div>
          <div class="input-element">
            <label>Right</label>

            <input
              v-model.number="
                task.props.settings.layout.customSpacing[selectedScreen].right
                  .value
              "
              type="number"
            />
            <CustomDropdown>
              <template v-slot:selected-option>
                <span class="line-clamp"
                  >{{ layoutSetting?.customSpacing[selectedScreen].right.unit }}
                </span>
              </template>
              <template v-slot:option-data>
                <b-dropdown-item
                  v-for="unit in unitOptions"
                  :key="unit"
                  @click="onSelectSpacingUnit(unit, 'right')"
                >
                  {{ unit }}
                </b-dropdown-item>
              </template>
            </CustomDropdown>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommonSwitch from '@/components/widgets/CommonSwitch.vue';
import CustomDropdown from '../widgets/CustomDropdown.vue';
export default {
  name: 'formLayoutSetting',
  data() {
    return {
      layoutSpacingOptions: [
        { label: 'Keine Marge', value: 'fullwidth' },
        { label: 'Standardmarge', value: 'standard' },
        { label: 'Großer Spielraum', value: 'largemargin' },
        { label: 'Benutzerdefinierter Rand', value: 'custom' },
      ],

      screenSizeOptions: [
        {
          name: 'mobile',
          icon: 'mobile-screen.svg',
          activeIcon: 'mobile-screen-active.svg',
        },
        {
          name: 'tablet',
          icon: 'tablet-screen.svg',
          activeIcon: 'tablet-screen-active.svg',
        },
        {
          name: 'laptop',
          icon: 'laptop-screen.svg',
          activeIcon: 'laptop-screen-active.svg',
        },
        {
          name: 'desktop',
          icon: 'dekstop-screen.svg',
          activeIcon: 'dekstop-screen-active.svg',
        },
      ],
      unitOptions: ['px', '%'],
      selectedScreen: 'desktop',
    };
  },
  props: {
    process: {
      type: Object,
      default: () => {},
    },
    task: {
      type: Object,
      default: () => {},
    },
    currentScreen: {
      type: String,
      default: 'desktop',
    },
    isUserHasAccess: { type: Boolean, default: true },
  },

  methods: {
    onChnageLayoutSpacing(event) {
      if (event.target.value == 'custom') {
        this.setDefaultCustomLayoutSpacing();
      }
    },
    getScreenIcons(iconName) {
      return require(`@/assets/img/page-builder-icons/${iconName}`);
    },

    onSelectScreen(screen) {
      this.selectedScreen = screen.name;
      this.$emit('onChangeCustomSpacingScreen', screen.name);
      this.setDefaultCustomLayoutSpacing();
    },
    onCustomLayoutSpacingInput(event, direction) {
      this.$set(
        this.task.props.settings.layout.customSpacing[this.selectedScreen],
        direction,
        parseInt(event.target.value)
      );
    },
    onSelectSpacingUnit(unit, direction) {
      this.task.props.settings.layout.customSpacing[this.selectedScreen][
        direction
      ].unit = unit;
    },
    setDefaultCustomLayoutSpacing() {
      if (this.layoutSetting?.spacing == 'custom') {
        if (!this.layoutSetting?.hasOwnProperty('customSpacing')) {
          this.$set(this.task.props.settings.layout, 'customSpacing', {});
        }
        if (
          !this.layoutSetting.customSpacing.hasOwnProperty(this.selectedScreen)
        ) {
          this.$set(
            this.task.props.settings.layout.customSpacing,
            this.selectedScreen,
            {
              top: { value: 0, unit: 'px' },
              left: { value: 0, unit: 'px' },
              bottom: { value: 0, unit: 'px' },
              right: { value: 0, unit: 'px' },
            }
          );
        }
      }
    },
    onValueChange(value) {
      if (value == 'custom') {
        this.setDefaultCustomLayoutSpacing();
      }
    },
  },
  created() {
    if (!this.task?.props.settings?.hasOwnProperty('layout')) {
      this.$set(this.task.props.settings, 'layout', {});
      this.$set(this.task.props.settings.layout, 'spacing', 'standard');
    }
    this.setDefaultCustomLayoutSpacing();
    this.selectedScreen = this.currentScreen;
  },
  computed: {
    layoutSetting() {
      return this.task.props.settings.layout;
    },
  },
  components: {
    CommonSwitch,
    CustomDropdown,
  },
};
</script>

<style scoped>
.form-layout-settings .switch-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.form-layout-settings {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.form-layout-settings .screen-selector {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 16px;
  height: 100px;
}

.form-layout-settings .screen-icon {
  cursor: pointer;
}

.form-layout-settings .custom-dropdown {
  width: 40px !important;
}

.form-layout-settings ::v-deep .custom-dropdown-toggle {
  width: 45px !important;
  padding-inline: 4px !important;
  border-radius: 0 !important;
  height: 100% !important;
  border: 1px solid #dee3e9 !important;
  border-left: none !important;
  font-size: 16px;
}

.form-layout-settings ::v-deep .custom-dropdown-menu {
  width: 64px !important;
}

.form-layout-settings .layout-spacing-inputs label {
  width: 25px;
  padding: 0;
}

.form-layout-settings .layout-spacing-inputs .input-element {
  width: 100%;
}

.form-layout-settings .layout-spacing-inputs > div > div:nth-child(2) label {
  width: 50px;
}

.form-layout-settings .layout-spacing-inputs > div {
  display: flex;
  flex-direction: row;
}

.form-layout-settings .layout-spacing-inputs .input-element input {
  margin: 0;
  width: 65px;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  box-sizing: border-box;
  padding: 0px 6px 0px 6px;
  outline: none !important;
}
.form-layout-settings .layout-spacing-inputs .input-element {
  display: flex;
  flex-direction: row;
  padding: 0;
  align-items: center;
  margin-top: 16px;
}

.form-layout-settings .layout-spacing-inputs label {
  width: 25px;
  padding: 0;
  margin-right: 10px;
}
</style>
